import axios from '@/utils/axios';

export function ListUrbanArea() {
    return axios({
        url: '/area/urban/list',
        method: 'get'
    });
}